import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateSepulturaForm } from '../Validations/ValidationsSepultura';

export default function EditSepulturaForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        tipoId: '',
        lugareId: '',
        serie: '',
        numero: '',
        fechaDocumento: '',
        terceroId: '',
        fechaConcesion: '',
        clausurado: '',
      //  ocupado: '',
        ocupado: 0,
        importeTasa: '',
        cuentaBancaria: '',
        bonificado: '',       
        observaciones: '',
        contacto: '',
        domicilio: '',
        telefono: '',
        gps: '',
        mapeo: '',
        trasladoId: '',
        createdAt: '',
        updatedAt: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSepultura = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/sepulturasc/${id}`);
                setFormData({
                    id: response.data.id || '',
                    tipoId: response.data.tipoId || '',
                    lugareId: response.data.lugareId || '',
                    serie: response.data.serie || '',
                    numero: response.data.numero || '',
                    fechaDocumento: response.data.fechaDocumento || '',
                    terceroId: response.data.terceroId || '',
                    fechaConcesion: response.data.fechaConcesion || '',
                    clausurado: response.data.clausurado || '',
                  //  ocupado: response.data.ocupado || '',
                    ocupado: response.data.ocupado ? 1 : 0, // <-- Convertir a número
                    importeTasa: response.data.importeTasa || '',
                    cuentaBancaria: response.data.cuentaBancaria || '',
                    bonificado: response.data.bonificado || '',                    
                    observaciones: response.data.observaciones || '',                    
                    contacto: response.data.contacto || '',
                    domicilio: response.data.domicilio || '',
                    telefono: response.data.telefono || '',
                    gps: response.data.gps || '',
                    mapeo: response.data.mapeo || '',
                    trasladoId: response.data.trasladoId || '',
                    createdAt: response.data.createdAt || '',
                    updatedAt: response.data.updatedAt || ''
                
                    });
            } catch (err) {
                setError('Error al cargar los datos de la sepultura.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchSepultura();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateSepulturaForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                // Solo enviar las propiedades necesarias
                const payload = {
                    observaciones: formData.observaciones,
                    contacto: formData.contacto,
                    domicilio: formData.domicilio,
                    telefono: formData.telefono,
                    cuentaBancaria: formData.cuentaBancaria,
                    ocupado: Number(formData.ocupado), // <-- Convertir a número
                    fechaConcesion: formData.fechaConcesion,
                    serie: formData.serie,
                    numero: formData.numero

                };
                console.log("Payload enviado al backend:", payload); // <-- Agregar
                await axios.put(`/sepulturasc/${id}`, payload);
                navigate('/home/sepulturas');
            } catch (err) {
                console.error('Error al actualizar la sepultura:', err.response || err.message);
                setError('Error al actualizar la sepultura. Por favor, intente de nuevo.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-4xl mx-auto mt-8 p-6 bg-blue-50 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-blue-800">Editar Sepultura</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    
                    <div>
                        <label className="block mb-2 text-blue-700">ID</label>
                        <input
                            type="text"
                            name="id"
                            value={formData.id}
                            className="w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500"
                            required
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Observaciones</label>
                        <input
                            type="text"
                            name="observaciones"
                            value={formData.observaciones}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.observaciones ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.observaciones && <p className="text-red-500 text-xs italic mt-1">{errors.observaciones}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Cuenta Bancaria</label>
                        <input
                            type="text"
                            name="cuentaBancaria"
                            value={formData.cuentaBancaria}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.cuentaBancaria ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.cuentaBancaria && <p className="text-red-500 text-xs italic mt-1">{errors.cuentaBancaria}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Contacto</label>
                        <input
                            type="text"
                            name="contacto"
                            value={formData.contacto}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.contacto ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.contacto && <p className="text-red-500 text-xs italic mt-1">{errors.contacto}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Domicilio</label>
                        <input
                            type="text"
                            name="domicilio"
                            value={formData.domicilio}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.domicilio ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.domicilio && <p className="text-red-500 text-xs italic mt-1">{errors.domicilio}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Teléfono</label>
                        <input
                            type="text"
                            name="telefono"
                            value={formData.telefono}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.telefono ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.telefono && <p className="text-red-500 text-xs italic mt-1">{errors.telefono}</p>}
                    </div>

                    <div>
                        <label className="block mb-2 text-blue-700">Fecha Concesion</label>
                        <input
                            type="text"
                            name="fechaConcesion"
                            value={formData.fechaConcesion}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.fechaConcesion ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.telefono && <p className="text-red-500 text-xs italic mt-1">{errors.fechaConcesion}</p>}
                    </div>

  <div>
    <label className="block mb-2 text-blue-700">Ocupado</label>
    <select
        name="ocupado"
        value={formData.ocupado}
        onChange={(e) => setFormData({ ...formData, ocupado: Number(e.target.value) })} // Convertir a número
        className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.ocupado ? 'border-red-500' : ''}`}
        required
    >
        <option value={0}>No</option>
        <option value={1}>Sí</option>
    </select>
    {errors.ocupado && <p className="text-red-500 text-xs italic mt-1">{errors.ocupado}</p>}
</div>
                 
<div>
    <label className="block mb-2 text-blue-700">Serie</label>
    <input
        type="text"
        name="serie"
        value={formData.serie}
        onChange={handleChange}
        className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.serie ? 'border-red-500' : ''}`}
        required
    />
    {errors.serie && <p className="text-red-500 text-xs italic mt-1">{errors.serie}</p>}
</div>

<div>
    <label className="block mb-2 text-blue-700">Número</label>
    <input
        type="text"
        name="numero"
        value={formData.numero}
        onChange={handleChange}
        className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.numero ? 'border-red-500' : ''}`}
        required
    />
    {errors.numero && <p className="text-red-500 text-xs italic mt-1">{errors.numero}</p>}
</div>
                   
                </div>
                
                <div className="mt-6">
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition duration-300"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Actualizando...' : 'Actualizar Sepultura'}
                    </button>
                </div>
            </form>
        </div>
    );
}


/*
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateSepulturaForm } from '../Validations/ValidationsSepultura';

export default function EditSepulturaForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        tipoId: '',
        lugareId: '',
        serie: '',
        numero: '',
        fechaDocumento: '',
        terceroId: '',
        fechaConcesion: '',
        clausurado: '',
      //  ocupado: '',
        ocupado: 0,
        importeTasa: '',
        cuentaBancaria: '',
        bonificado: '',       
        observaciones: '',
        contacto: '',
        domicilio: '',
        telefono: '',
        gps: '',
        mapeo: '',
        trasladoId: '',
        createdAt: '',
        updatedAt: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSepultura = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/sepulturasc/${id}`);
                setFormData({
                    id: response.data.id || '',
                    tipoId: response.data.tipoId || '',
                    lugareId: response.data.lugareId || '',
                    serie: response.data.serie || '',
                    numero: response.data.numero || '',
                    fechaDocumento: response.data.fechaDocumento || '',
                    terceroId: response.data.terceroId || '',
                    fechaConcesion: response.data.fechaConcesion || '',
                    clausurado: response.data.clausurado || '',
                  //  ocupado: response.data.ocupado || '',
                    ocupado: response.data.ocupado ? 1 : 0, // <-- Convertir a número
                    importeTasa: response.data.importeTasa || '',
                    cuentaBancaria: response.data.cuentaBancaria || '',
                    bonificado: response.data.bonificado || '',                    
                    observaciones: response.data.observaciones || '',                    
                    contacto: response.data.contacto || '',
                    domicilio: response.data.domicilio || '',
                    telefono: response.data.telefono || '',
                    gps: response.data.gps || '',
                    mapeo: response.data.mapeo || '',
                    trasladoId: response.data.trasladoId || '',
                    createdAt: response.data.createdAt || '',
                    updatedAt: response.data.updatedAt || ''
                
                    });
            } catch (err) {
                setError('Error al cargar los datos de la sepultura.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchSepultura();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateSepulturaForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                // Solo enviar las propiedades necesarias
                const payload = {
                    observaciones: formData.observaciones,
                    contacto: formData.contacto,
                    domicilio: formData.domicilio,
                    telefono: formData.telefono,
                    cuentaBancaria: formData.cuentaBancaria,
                    ocupado: Number(formData.ocupado), // <-- Convertir a número
                    fechaConcesion: formData.fechaConcesion

                };
                console.log("Payload enviado al backend:", payload); // <-- Agregar
                await axios.put(`/sepulturasc/${id}`, payload);
                navigate('/home/sepulturas');
            } catch (err) {
                console.error('Error al actualizar la sepultura:', err.response || err.message);
                setError('Error al actualizar la sepultura. Por favor, intente de nuevo.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-4xl mx-auto mt-8 p-6 bg-blue-50 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-blue-800">Editar Sepultura</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    
                    <div>
                        <label className="block mb-2 text-blue-700">ID</label>
                        <input
                            type="text"
                            name="id"
                            value={formData.id}
                            className="w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500"
                            required
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Observaciones</label>
                        <input
                            type="text"
                            name="observaciones"
                            value={formData.observaciones}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.observaciones ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.observaciones && <p className="text-red-500 text-xs italic mt-1">{errors.observaciones}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Cuenta Bancaria</label>
                        <input
                            type="text"
                            name="cuentaBancaria"
                            value={formData.cuentaBancaria}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.cuentaBancaria ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.cuentaBancaria && <p className="text-red-500 text-xs italic mt-1">{errors.cuentaBancaria}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Contacto</label>
                        <input
                            type="text"
                            name="contacto"
                            value={formData.contacto}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.contacto ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.contacto && <p className="text-red-500 text-xs italic mt-1">{errors.contacto}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Domicilio</label>
                        <input
                            type="text"
                            name="domicilio"
                            value={formData.domicilio}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.domicilio ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.domicilio && <p className="text-red-500 text-xs italic mt-1">{errors.domicilio}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Teléfono</label>
                        <input
                            type="text"
                            name="telefono"
                            value={formData.telefono}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.telefono ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.telefono && <p className="text-red-500 text-xs italic mt-1">{errors.telefono}</p>}
                    </div>

                    <div>
                        <label className="block mb-2 text-blue-700">Fecha Concesion</label>
                        <input
                            type="text"
                            name="fechaConcesion"
                            value={formData.fechaConcesion}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.fechaConcesion ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.telefono && <p className="text-red-500 text-xs italic mt-1">{errors.fechaConcesion}</p>}
                    </div>

  <div>
    <label className="block mb-2 text-blue-700">Ocupado</label>
    <select
        name="ocupado"
        value={formData.ocupado}
        onChange={(e) => setFormData({ ...formData, ocupado: Number(e.target.value) })} // Convertir a número
        className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.ocupado ? 'border-red-500' : ''}`}
        required
    >
        <option value={0}>No</option>
        <option value={1}>Sí</option>
    </select>
    {errors.ocupado && <p className="text-red-500 text-xs italic mt-1">{errors.ocupado}</p>}
</div>
             


                   
                </div>
                
                <div className="mt-6">
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition duration-300"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Actualizando...' : 'Actualizar Sepultura'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/



/* anterior correcto
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateSepulturaForm } from '../Validations/ValidationsSepultura';

export default function EditSepulturaForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        tipoId: '',
        lugareId: '',
        serie: '',
        numero: '',
        fechaDocumento: '',
        terceroId: '',
        fechaConcesion: '',
        clausurado: '',
        ocupado: '',
        importeTasa: '',
        cuentaBancaria: '',
        bonificado: '',       
        observaciones: '',
        contacto: '',
        domicilio: '',
        telefono: '',
        gps: '',
        mapeo: '',
        trasladoId: '',
        createdAt: '',
        updatedAt: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSepultura = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/sepulturasc/${id}`);
                setFormData({
                    id: response.data.id || '',
                    tipoId: response.data.tipoId || '',
                    lugareId: response.data.lugareId || '',
                    serie: response.data.serie || '',
                    numero: response.data.numero || '',
                    fechaDocumento: response.data.fechaDocumento || '',
                    terceroId: response.data.terceroId || '',
                    fechaConcesion: response.data.fechaConcesion || '',
                    clausurado: response.data.clausurado || '',
                    ocupado: response.data.ocupado || '',
                    importeTasa: response.data.importeTasa || '',
                    cuentaBancaria: response.data.cuentaBancaria || '',
                    bonificado: response.data.bonificado || '',                    
                    observaciones: response.data.observaciones || '',                    
                    contacto: response.data.contacto || '',
                    domicilio: response.data.domicilio || '',
                    telefono: response.data.telefono || '',
                    gps: response.data.gps || '',
                    mapeo: response.data.mapeo || '',
                    trasladoId: response.data.trasladoId || '',
                    createdAt: response.data.createdAt || '',
                    updatedAt: response.data.updatedAt || ''
                
                    });
            } catch (err) {
                setError('Error al cargar los datos de la sepultura.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchSepultura();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateSepulturaForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                // Solo enviar las propiedades necesarias
                const payload = {
                    observaciones: formData.observaciones,
                    contacto: formData.contacto,
                    domicilio: formData.domicilio,
                    telefono: formData.telefono,
                    cuentaBancaria: formData.cuentaBancaria,
                    fechaConcesion: formData.fechaConcesion

                };
                console.log("Payload enviado al backend:", payload); // <-- Agregar
                await axios.put(`/sepulturasc/${id}`, payload);
                navigate('/home/sepulturas');
            } catch (err) {
                console.error('Error al actualizar la sepultura:', err.response || err.message);
                setError('Error al actualizar la sepultura. Por favor, intente de nuevo.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-4xl mx-auto mt-8 p-6 bg-blue-50 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-blue-800">Editar Sepultura</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    
                    <div>
                        <label className="block mb-2 text-blue-700">ID</label>
                        <input
                            type="text"
                            name="id"
                            value={formData.id}
                            className="w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500"
                            required
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Observaciones</label>
                        <input
                            type="text"
                            name="observaciones"
                            value={formData.observaciones}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.observaciones ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.observaciones && <p className="text-red-500 text-xs italic mt-1">{errors.observaciones}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Cuenta Bancaria</label>
                        <input
                            type="text"
                            name="cuentaBancaria"
                            value={formData.cuentaBancaria}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.cuentaBancaria ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.cuentaBancaria && <p className="text-red-500 text-xs italic mt-1">{errors.cuentaBancaria}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Contacto</label>
                        <input
                            type="text"
                            name="contacto"
                            value={formData.contacto}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.contacto ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.contacto && <p className="text-red-500 text-xs italic mt-1">{errors.contacto}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Domicilio</label>
                        <input
                            type="text"
                            name="domicilio"
                            value={formData.domicilio}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.domicilio ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.domicilio && <p className="text-red-500 text-xs italic mt-1">{errors.domicilio}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Teléfono</label>
                        <input
                            type="text"
                            name="telefono"
                            value={formData.telefono}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.telefono ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.telefono && <p className="text-red-500 text-xs italic mt-1">{errors.telefono}</p>}
                    </div>

                    <div>
                        <label className="block mb-2 text-blue-700">Fecha Concesion</label>
                        <input
                            type="text"
                            name="fechaConcesion"
                            value={formData.fechaConcesion}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.fechaConcesion ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.telefono && <p className="text-red-500 text-xs italic mt-1">{errors.fechaConcesion}</p>}
                    </div>
                   
                </div>
                
                <div className="mt-6">
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition duration-300"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Actualizando...' : 'Actualizar Sepultura'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/

/* CORRECTO

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateSepulturaForm } from '../Validations/ValidationsSepultura';

export default function EditSepulturaForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        tipoId: '',
        lugareId: '',
        serie: '',
        numero: '',
        fechaDocumento: '',
        terceroId: '',
        fechaConcesion: '',
        clausurado: '',
        ocupado: '',
        importeTasa: '',
        cuentaBancaria: '',
        bonificado: '',       
        observaciones: '',
        contacto: '',
        domicilio: '',
        telefono: '',
        gps: '',
        mapeo: '',
        trasladoId: '',
        createdAt: '',
        updatedAt: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSepultura = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/sepulturasc/${id}`);
                setFormData({
                    id: response.data.id || '',
                    tipoId: response.data.tipoId || '',
                    lugareId: response.data.lugareId || '',
                    serie: response.data.serie || '',
                    numero: response.data.numero || '',
                    fechaDocumento: response.data.fechaDocumento || '',
                    terceroId: response.data.terceroId || '',
                    fechaConcesion: response.data.fechaConcesion || '',
                    clausurado: response.data.clausurado || '',
                    ocupado: response.data.ocupado || '',
                    importeTasa: response.data.importeTasa || '',
                    cuentaBancaria: response.data.cuentaBancaria || '',
                    bonificado: response.data.bonificado || '',                    
                    observaciones: response.data.observaciones || '',                    
                    contacto: response.data.contacto || '',
                    domicilio: response.data.domicilio || '',
                    telefono: response.data.telefono || '',
                    gps: response.data.gps || '',
                    mapeo: response.data.mapeo || '',
                    trasladoId: response.data.trasladoId || '',
                    createdAt: response.data.createdAt || '',
                    updatedAt: response.data.updatedAt || ''
                
                    });
            } catch (err) {
                setError('Error al cargar los datos de la sepultura.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchSepultura();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateSepulturaForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                // Solo enviar las propiedades necesarias
                const payload = {
                    observaciones: formData.observaciones,
                    contacto: formData.contacto,
                    domicilio: formData.domicilio,
                    telefono: formData.telefono,
                    cuentaBancaria: formData.cuentaBancaria

                };
                console.log("Payload enviado al backend:", payload); // <-- Agregar
                await axios.put(`/sepulturasc/${id}`, payload);
                navigate('/home/sepulturas');
            } catch (err) {
                console.error('Error al actualizar la sepultura:', err.response || err.message);
                setError('Error al actualizar la sepultura. Por favor, intente de nuevo.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-4xl mx-auto mt-8 p-6 bg-blue-50 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-blue-800">Editar Sepultura</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    
                    <div>
                        <label className="block mb-2 text-blue-700">ID</label>
                        <input
                            type="text"
                            name="id"
                            value={formData.id}
                            className="w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500"
                            required
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Observaciones</label>
                        <input
                            type="text"
                            name="observaciones"
                            value={formData.observaciones}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.observaciones ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.observaciones && <p className="text-red-500 text-xs italic mt-1">{errors.observaciones}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Cuenta Bancaria</label>
                        <input
                            type="text"
                            name="cuentaBancaria"
                            value={formData.cuentaBancaria}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.cuentaBancaria ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.cuentaBancaria && <p className="text-red-500 text-xs italic mt-1">{errors.cuentaBancaria}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Contacto</label>
                        <input
                            type="text"
                            name="contacto"
                            value={formData.contacto}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.contacto ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.contacto && <p className="text-red-500 text-xs italic mt-1">{errors.contacto}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Domicilio</label>
                        <input
                            type="text"
                            name="domicilio"
                            value={formData.domicilio}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.domicilio ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.domicilio && <p className="text-red-500 text-xs italic mt-1">{errors.domicilio}</p>}
                    </div>
                    <div>
                        <label className="block mb-2 text-blue-700">Teléfono</label>
                        <input
                            type="text"
                            name="telefono"
                            value={formData.telefono}
                            onChange={handleChange}
                            className={`w-full p-3 border border-blue-200 rounded-lg focus:outline-none focus:border-blue-500 ${errors.telefono ? 'border-red-500' : ''}`}
                            required
                        />
                        {errors.telefono && <p className="text-red-500 text-xs italic mt-1">{errors.telefono}</p>}
                    </div>
                </div>
                
                <div className="mt-6">
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition duration-300"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Actualizando...' : 'Actualizar Sepultura'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/
/*
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateSepulturaForm } from '../Validations/ValidationsSepultura';

export default function EditSepulturaForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        tipoId: '',
        lugareId: '',
        serie: '',
        numero: '',
        fechaDocumento: '',
        terceroId: '',
        fechaConcesion: '',
        clausurado: '',
        ocupado: '',
        importeTasa: '',
        cuentaBancaria: '',
        bonificado: '',       
        observaciones: '',
        contacto: '',
        domicilio: '',
        telefono: '',
        gps: '',
        mapeo: '',
        trasladoId: '',
        createdAt: '',
        updatedAt: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSepultura = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/sepulturasc/${id}`);
                setFormData({
                    id: response.data.id || '',
                    tipoId: response.data.tipoId || '',
                    lugareId: response.data.lugareId || '',
                    serie: response.data.serie || '',
                    numero: response.data.numero || '',
                    fechaDocumento: response.data.fechaDocumento || '',
                    terceroId: response.data.terceroId || '',
                    fechaConcesion: response.data.fechaConcesion || '',
                    clausurado: response.data.clausurado || '',
                    ocupado: response.data.ocupado || '',
                    importeTasa: response.data.importeTasa || '',
                    cuentaBancaria: response.data.cuentaBancaria || '',
                    bonificado: response.data.bonificado || '',                    
                    observaciones: response.data.observaciones || '',                    
                    contacto: response.data.contacto || '',
                    domicilio: response.data.domicilio || '',
                    telefono: response.data.telefono || '',
                    gps: response.data.gps || '',
                    mapeo: response.data.mapeo || '',
                    trasladoId: response.data.trasladoId || '',
                    createdAt: response.data.createdAt || '',
                    updatedAt: response.data.updatedAt || ''
                
                    });
            } catch (err) {
                setError('Error al cargar los datos de la sepultura.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchSepultura();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateSepulturaForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                // Solo enviar las propiedades necesarias
                const payload = {
                    observaciones: formData.observaciones,
                    contacto: formData.contacto,
                    domicilio: formData.domicilio,
                    telefono: formData.telefono,
                    cuentaBancaria: formData.cuentaBancaria

                };
                console.log("Payload enviado al backend:", payload); // <-- Agregar
                await axios.put(`/sepulturasc/${id}`, payload);
                navigate('/home/sepulturas');
            } catch (err) {
                console.error('Error al actualizar la sepultura:', err.response || err.message);
                setError('Error al actualizar la sepultura. Por favor, intente de nuevo.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-2xl mx-auto mt-8">
            <h2 className="text-2xl font-bold mb-4">Editar Sepultura</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block mb-1">ID</label>
                    <input
                        type="text"
                        name="id"
                        value={formData.id}
                        className="w-full p-2 border rounded"
                        required
                        readOnly
                    />
                </div>
                <div>
                    <label className="block mb-1">Observaciones</label>
                    <input
                        type="text"
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.observaciones ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.observaciones && <p className="text-red-500 text-xs italic">{errors.observaciones}</p>}
                </div>
                <div>
                    <label className="block mb-1">Cuenta Bancaria</label>
                    <input
                        type="text"
                        name="cuentaBancaria"
                        value={formData.cuentaBancaria}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.cuentaBancaria ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.cuentaBancaria && <p className="text-red-500 text-xs italic">{errors.cuentaBancaria}</p>}
                </div>
                <div>
                    <label className="block mb-1">Contacto</label>
                    <input
                        type="text"
                        name="contacto"
                        value={formData.contacto}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.contacto ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.contacto && <p className="text-red-500 text-xs italic">{errors.contacto}</p>}
                </div>
                <div>
                    <label className="block mb-1">Domicilio</label>
                    <input
                        type="text"
                        name="domicilio"
                        value={formData.domicilio}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.domicilio ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.domicilio && <p className="text-red-500 text-xs italic">{errors.domicilio}</p>}
                </div>
                <div>
                    <label className="block mb-1">Teléfono</label>
                    <input
                        type="text"
                        name="telefono"
                        value={formData.telefono}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.telefono ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.telefono && <p className="text-red-500 text-xs italic">{errors.telefono}</p>}
                </div>
                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
                    disabled={isLoading}
                >
                    {isLoading ? 'Actualizando...' : 'Actualizar Sepultura'}
                </button>
            </form>
        </div>
    );

}
*/